import { foodImage, cardfood3, logo } from "@/assets";

const Template2 = ({ template, previewData }) => {
  const isStrictPreview = Boolean(previewData?.strictTablePreview);
  const backgroundImage = template?.image_url || foodImage;
  const logoImage = template?.logo_url || logo;
  const title = previewData?.title || (isStrictPreview ? "No provide" : "GIFT VOUCHER");
  const customerName =
    previewData?.customerName || (isStrictPreview ? "No provide" : "Md Rasel Mahmud");
  const code = previewData?.code || (isStrictPreview ? "No provide" : "32154232");
  const message = previewData?.message || (isStrictPreview ? "No provide" : "Happy Birthday");
  const templateNote = previewData?.template_note;

  return (
    <div className="flex items-center justify-center p-4">
      <div
        data-export-capture="c2c-template"
        className="relative w-full max-w-2xl h-[300px] shadow-2xl overflow-hidden rounded-sm flex bg-black"
      >
        <div
          className="absolute inset-0 w-full h-full bg-cover bg-center opacity-40"
          style={{ backgroundImage: `url(${backgroundImage})` }}
        ></div>

        <div
          className="absolute inset-0 bg-[#003B4A] z-10"
          style={{ clipPath: "polygon(44% 0, 100% 0, 100% 100%, 30% 100%)" }}
        ></div>

        {/* <div className="absolute left-[30px] top-1/2 -translate-y-1/2 ">
          <div className="w-[180px] h-[180px] rounded-full border-[8px] border-white shadow-2xl overflow-hidden">
            <img
              src={cardfood3}
              alt="Voucher Food"
              className="w-full h-full object-cover scale-110"
            />
          </div>
        </div> */}

        <div className="relative z-20 w-full h-full flex flex-col justify-between pl-[42%] pr-8 py-5 text-white">
          <div>
            {/* Header */}
            <h1 className="text-xl font-bold uppercase tracking-tight leading-none mb-1 text-amber-400">
              {title}
            </h1>

            {/* User Details */}
            <div className="mt-1 space-y-0.5 mb-2">
              <p className="text-base font-serif italic text-gray-200">
                {customerName}
              </p>
              <p className="text-[10px] font-normal tracking-wide text-gray-300">
                Code: {code}
              </p>
            </div>

            {previewData?.items && previewData.items.length > 0 ? (
              <div className="mb-2 w-full text-left">
                <p className="text-[9px] uppercase tracking-widest text-amber-400/90 font-bold mb-0.5">GIFT ITEMS</p>
                <p className="text-[11px] text-gray-200 font-mono leading-tight">
                  {previewData.items.map((item) => {
                    const name = item?.menu_item?.name || item?.name || "";
                    const variant = item?.variant?.name ? ` (${item.variant.name})` : item?.variant_name ? ` (${item.variant_name})` : "";
                    return `${name}${variant}`;
                  }).join(", ")}
                </p>
              </div>
            ) : previewData?.reward ? (
              <div className="mb-2 px-3 py-0.5 bg-amber-500/20 border border-amber-500/30 rounded text-amber-300 font-bold text-xs inline-block">
                Value: £{previewData.reward}
              </div>
            ) : null}

            {templateNote ? (
              <p className="text-xs text-gray-300 font-sans leading-tight mt-1">
                {templateNote}
              </p>
            ) : null}
          </div>

          <div className="mt-auto border-t border-white/10 pt-2 w-full">
            {/* Anniversary/Birthday Message */}
            <p className="text-base font-extralight italic tracking-tight text-white leading-none mb-2">
              {message}
            </p>
            <div className="flex justify-between items-center">
              <img src={logoImage} alt="Logo" className="h-5 w-auto object-contain opacity-80" />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Template2;
